(() => {
    let perks = document.querySelectorAll('.the-perks');

    if (perks.length) {
        perks.forEach((perk) => {
            let wooshTimeout;
            let nextPerkTimeout;

            let selectedIndex = 0;

            const perkItems = perk.querySelectorAll('.the-perks--perk');
            const targetImage = perk.querySelector('.the-perks--big-image img');
            const numOfPerks = perkItems.length;

            const setPerkImage = (blob) => {
                if (blob != targetImage.getAttribute('src')) {
                    targetImage.parentElement.classList.add('--change');

                    clearTimeout(wooshTimeout);

                    wooshTimeout = setTimeout(() => {
                        targetImage.setAttribute('src', blob);
                        targetImage.parentElement.classList.remove('--change');
                    }, 100);
                }
            }

            const selectPerk = async (indexToSelect) => {
                let perkItem = perkItems[indexToSelect];

                let blob = perkItem.getAttribute('blob');

                if (!blob) {
                    await fetch(perkItem.getAttribute('large-image'))
                        .then(res => res.blob())
                        .then(blob => {
                            blob = URL.createObjectURL(blob);
                            perkItem.setAttribute('blob', blob);

                            setPerkImage(blob);
                        });
                } else {
                    setPerkImage(blob);
                }

                let lastPerk = perk.querySelector('.--current');
                if (lastPerk) {
                    lastPerk.classList.remove('--current');
                }

                perkItem.classList.add('--current');

                showNextPerk();
            }
            
            const showNextPerk = () => {
                if (nextPerkTimeout) {
                    clearTimeout(nextPerkTimeout);
                }

                nextPerkTimeout = setTimeout(() => {
                    if (selectedIndex > numOfPerks - 2) {
                        selectedIndex = 0;
                    } else {
                        selectedIndex++;
                    }

                    selectPerk(selectedIndex);
                }, 3000);
            }


            perkItems.forEach((perkItem) => {
                perkItem.addEventListener('mouseenter', () => {
                    let index = Array.prototype.indexOf.call(perkItem.parentNode.children, perkItem);

                    selectPerk(index);
                    selectedIndex = index;
                });
            });

            selectPerk(0);
        });
    }
})();